/**
         * Include your custom JavaScript here.
         *
         * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
         * changes on product page, you can attach a listener to the document:
         *
         * document.addEventListener('variant:changed', function(event) {
         *   var variant = event.detail.variant; // Gives you access to the whole variant details
         * });
         *
         * You can also add a listener whenever a product is added to the cart:
         *
         * document.addEventListener('product:added', function(event) {
         *   var variant = event.detail.variant; // Get the variant that was added
         *   var quantity = event.detail.quantity; // Get the quantity that was added
         * });
         *
         * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
         * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
         * that was added so the theme can properly update the quantity:
         *
         * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
         *   bubbles: true,
         *   detail: {
         *     quantity: 1
         *   }
         * }));
         *
         * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
         * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
         *
         * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         *   bubbles: true
         * }));
         */


let shopLocale = document.querySelector('html').getAttribute("lang");

let idioms = {
  "es" : {
    "btnSubmit" : "Enviar",
    "btnCheck" : "Comprobando", 
    "registerTitle" : "¡ Rellena tus datos !",
    "titlePreference" : "¡ Rellena tus datos ahora y empieza a ahorrar !",
    "notReadable" : "Dominio no legible"
  },
  "en" : {
    "btnSubmit" : "Submit",
    "btnCheck" : "Checking", 
    "registerTitle" : "¡ Fill in your data !",
    "titlePreference" : "¡ Fill in your details now and start saving !",
    "notReadable" : "Domain not readable"
  },
  "fr" : {
    "btnSubmit" : "Envoyer",
    "btnCheck" : "Vérification", 
    "registerTitle" : "¡ Remplissez vos données !",
    "titlePreference" : "¡ Remplissez vos coordonnées maintenant et commencez à économiser !",
    "notReadable" : "Domaine non lisible"
  },
  "it" : {
    "btnSubmit" : "Spedire",
    "btnCheck" : "controllo", 
    "registerTitle" : "Inserisci i tuoi dati!",
    "titlePreference" : "Inserisci ora i tuoi dati e inizia a risparmiare!",
    "notReadable" : "Dominio non leggibile"
  },
  "de" : {
    "btnSubmit" : "Senden",
    "btnCheck" : "Überprüfung", 
    "registerTitle" : "Geben Sie Ihre Daten ein!",
    "titlePreference" : "Geben Sie jetzt Ihre Daten ein und beginnen Sie mit dem Sparen!",
    "notReadable" : "Domäne nicht lesbar"
  }
}


let idiomNav = navigator.language || navigator.userLanguage;

if(idiomNav.indexOf("es") >= 0 ){
  idiomNav = ""
}else if(idiomNav.indexOf("en") >= 0 ){
  idiomNav = "en"
}else if(idiomNav.indexOf("de") >= 0 ){
  idiomNav = "de"
}else if(idiomNav.indexOf("fr") >= 0 ){
  idiomNav = "fr"
}else if(idiomNav.indexOf("it") >= 0 ){
  idiomNav = "it"
}else{
  idiomNav = ""
}

const crearCookie = (key, value) => {
  
  expires = new Date();
  expires.setTime(expires.getTime() + 86400000); // Tiempo de expiración
  cookie = key + "=" + value + ";path=/;expires=" + expires.toUTCString();
  console.log("creando cookie 111")
  return (document.cookie = cookie);
};

const leerCookie = async (key) => {
  keyValue = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));  

  if (keyValue) {    
    return keyValue[2];
  } else {
    await crearCookie("CurrIdiom", "yes")
    
    console.log(idiomNav)
    console.log(window.location.pathname)
	let currentPath = window.location.pathname;
    if(currentPath.startsWith("/fr") || 
       currentPath.startsWith("/en") || 
       currentPath.startsWith("/it") || 
       currentPath.startsWith("/de") || 
       currentPath.startsWith("/pt") ){
      currentPath = currentPath.slice(3)
    }
      
    if(!window.location.pathname.includes("/"+idiomNav+"/") && idiomNav != "" ){
      //window.location = `${window.location.origin}/${idiomNav}${currentPath}`      
    }else if(idiomNav == "") {
        //window.location = `${window.location.origin}${currentPath}`
    }
    return false;
  }
};


//leerCookie("CurrIdiom") 


const validateEmail = (email) => {
  return String(email)
  .toLowerCase()
  .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

var currUserType = 'pro';

if (document.querySelector('#frm-validate') !== null) {

  const checkSite = (e) => {    
    e.preventDefault();  

    let $webSite = document.querySelector("#website").value.toLowerCase()
    let $eMail = document.querySelector("#mail").value.toLowerCase()


    if($webSite && $eMail && validateEmail($eMail)){
      e.submitter.innerText = `${idioms[shopLocale].btnCheck}...`

      const fn = async () => {
        const response  = await fetch('https://sign24h.com/a/validate', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            domain : $webSite,
            email : $eMail
          })
        })

        const data = await response.json();
        console.log(`data`)
        console.log(data)
        console.log(`data`)
        if(data.status === 'error'){
          e.submitter.innerText = `${idioms[shopLocale].btnSubmit}`;
          $(`<span id="error-email-use" style="color:red; margin:10px;display:block;">${data.message}</span>`).insertBefore(e.submitter);          
          setTimeout(function(){
            $('#error-email-use').remove();
          }, 5000);
        }else{

          if(data.data && !data.current_customer){
            let tagTitle = document.getElementById("frm-register-title");

            if(data.data.is_profesional === 1){
              tagTitle.innerHTML = `${idioms[shopLocale].titlePreference}`;
              let $msg_true = document.querySelector("#msg_success");
              $msg_true.classList.remove("hide");
              currUserType = 'pro';
            }else{
              tagTitle.innerHTML = `${idioms[shopLocale].registerTitle}`;
              let $msg_error = document.querySelector("#msg_err");

              $msg_error.classList.remove("hide");                            
              currUserType = '';
            }

            e.submitter.innerText = `${idioms[shopLocale].btnSubmit}`;

            let $hideFrm = document.querySelector(".globo-form-app")
            $hideFrm.classList.add("hide");

            let $fadeFrm = document.querySelector("#register-form")
            $fadeFrm.classList.remove("hide");

            let setEmail = document.getElementById("reg-email");
            setEmail.value = $eMail

            let head1 = document.getElementById("txt-header");
            head1.remove();

            window.scrollTo(0, 0);
          }

          if(data.current_customer){ 
            
            let tagTitle = document.getElementById("frm-register-title");

            if(data.data.is_profesional === 1){
              tagTitle.innerHTML = `${idioms[shopLocale].titlePreference}`;
              let $msg_true = document.querySelector("#msg_success");
              $msg_true.classList.remove("hide");
              currUserType = 'pro';
            }else{
              tagTitle.innerHTML = `${idioms[shopLocale].registerTitle}`;
              let $msg_error = document.querySelector("#msg_err");

              $msg_error.classList.remove("hide");                            
              currUserType = '';
            }

            e.submitter.innerText = `${idioms[shopLocale].btnSubmit}`;

            let $hideFrm = document.querySelector(".globo-form-app")
            $hideFrm.classList.add("hide");

            let $fadeFrm = document.querySelector("#register-form")
            $fadeFrm.classList.remove("hide");            

            let setName = document.getElementById("reg-name");
            setName.value = data.current_customer.customer.first_name

            let setLastName = document.getElementById("reg-last-name");
            setLastName.value = data.current_customer.customer.last_name  

            let setCompany = document.getElementById("reg-company");
            setCompany.value = data.current_customer.customer.company 

            console.log("*************")
            console.log(data.current_customer)

            let setEmail = document.getElementById("reg-email");
            setEmail.value = data.current_customer.customer.email

            let setPhone = document.getElementById("reg-phone");
            setPhone.value = data.current_customer.customer.phone

            if(data.current_customer.customer.default_address){
              let setLocal = document.getElementById("reg-localidad");
              setLocal.value = data.current_customer.customer.default_address.city

              let setFullAdress = document.getElementById("reg-full-address");
              setFullAdress.value = data.current_customer.customer.default_address.address1

              let setCountry = document.getElementById("reg-contry");
              setCountry.value = data.current_customer.customer.default_address.country_name

              let setProvince = document.getElementById("reg-provincia");
              setProvince.value = data.current_customer.customer.default_address.province

              let setZip = document.getElementById("reg-code");
              setZip.value = data.current_customer.customer.default_address.zip
            }

            let hidePassw = document.getElementById("reg-password").parentNode.classList.add("hide")
            document.getElementById("reg-password").value = 0

            document.getElementById("octocode-update-customer").setAttribute("data-id", data.current_customer.customer.id);
            document.getElementById("octocode-register-customer").classList.add("hide");
            document.getElementById("octocode-update-customer").classList.remove("hide");

            document.getElementById("reg-localidad").parentNode.classList.remove("layout-2-column");
            document.getElementById("reg-localidad").parentNode.classList.add("layout-1-column");

            let head1 = document.getElementById("txt-header");
            head1.remove();

            window.scrollTo(0, 0);

          }
        }
      }
      fn()
    }else{     
      let $emptyField = document.querySelector("#msg_emptyFields")
      $emptyField.classList.remove("hide");  
      setTimeout(function(){
        $emptyField.classList.add("hide"); 
      }, 3000)      
      return false
    }      
  }

  const form = document.getElementById('frm-validate');
  form.addEventListener('submit', checkSite);

  const tryAgain = () => {
    let $webSite = document.querySelector("#website")
    $webSite.value = ""
    $webSite.focus()
    document.querySelector("#mail").value = ""

    let $toHome = document.querySelector("#toHome")
    $toHome.classList.add("hide");  
  }

  /*const again = document.getElementById('again');
  again.addEventListener('click', tryAgain);*/
}

if (document.querySelector('.template-account') !== null) {
  const vatIdSubmit = document.getElementById("VatIdSubmit");

  if (vatIdSubmit) {
    vatIdSubmit.onclick = (e) => {
      const vatIdInput = document.getElementById("VatId");
      if (!vatIdInput) return;

      let $currentVatId = vatIdInput.value;
      let $idCustomer = e.target.dataset.customer


      const validateVat = async () => {
        const response  = await fetch('https://sign24h.com/a/validate', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            action : 'savevatid',
            customer_id : $idCustomer,
            vatid : $currentVatId,
          })
        })
        const data = await response.json()
      }
      validateVat()
    }
  }
}

const curreLanguage = function(){
  const languageLink = document.getElementById("open-lenguage-link");
  if (!languageLink) return;

  const currUrl = window.location.href;
  const currUrlArray = currUrl.split('/');
  const currLanguage = currUrlArray[3];
  let img = `<img src="https://cdn.shopify.com/s/files/1/0564/3245/9942/files/es.png?v=1649774659" alt="flag" />`;
  if(currLanguage==='en'){
    img = `<img src="https://cdn.shopify.com/s/files/1/0564/3245/9942/files/uk.png?v=1649774517" alt="flag" />`;
  }else if(currLanguage==='de'){
    img = `<img src="https://cdn.shopify.com/s/files/1/0564/3245/9942/files/de.png?v=1649774659" alt="flag" />`;
  }else if(currLanguage==='fr'){
    img = `<img src="https://cdn.shopify.com/s/files/1/0564/3245/9942/files/fr.png?v=1649774659" alt="flag" />`;
  }else if(currLanguage==='it'){
    img = `<img src="https://cdn.shopify.com/s/files/1/0564/3245/9942/files/it.png?v=1649774659" alt="flag" />`;
  }
  languageLink.innerHTML = img;
}

const languageLink = document.getElementById("open-lenguage-link");
if (languageLink) {
  languageLink.onclick = function(e){
    e.preventDefault();
    const footerLanguageSelector = document.querySelector('.footer__localization-form-item .select-button--mini');
    if (footerLanguageSelector) footerLanguageSelector.click();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  curreLanguage();
}, false);

document.querySelectorAll('[href="https://sign24h.com/account/login"]').forEach((item) => {  
  item.addEventListener("click", (e) => {        
   let pathname = window.location.pathname;
   crearCookie("backHistory", pathname)    
  });
});

document.querySelectorAll(".header__action-item-link").forEach((item) => {
  item.addEventListener("click", (e) => {        
   let pathname = window.location.pathname;   
   crearCookie("backHistory", pathname)    
  });
});
